import $ from 'jquery';
import { ITeamspeakComplain } from './interface';
import { Server } from '../units/server/server';
import VoiceServerQueryResponse = Server.VoiceServerQueryResponse;
import Utils from '../utils/utils';

const TEAMSPEAK_SELECTOR: string = '[data-teamspeak]';

export class TeamspeakUI {
    constructor(private $base: JQuery) {
    }
    
    public updateQueryInfo(queryResponse: VoiceServerQueryResponse) {
        this.$base.find('.voiceserver__current__players').text(queryResponse.online);
        this.$base.find('#tsMaxClients').text(queryResponse.slots);
        this.$base.find('.voiceserver__state').text(queryResponse.state);
    }
    
    public onTsdnsChange() {
        this.$base.find('#tsdns_domain').on('change', (e) => {
            if ($(e.currentTarget).val() == '0') {
                this.$base.find('#tsdns_tld').removeAttr('disabled');
                this.$base.find('#tsdns_tld').focus();
            } else {
                this.$base.find('#tsdns_tld').attr('disabled', 'disabled');
            }
        });
    }
    
    public onStatusButtonClick(callback: () => {}) {
        this.$base.find('.changeState').on('click', (e) => {
            e.preventDefault();
            callback();
        });
    }
    
    public onDeleteComplainButtonClick(callback: (complain: ITeamspeakComplain) => {}) {
        this.$base.find('.deleteComplain').on('click', (e: any) => {
            callback({
                fcldbid: $(e.currentTarget).data('fcldbid'),
                tcldbid: $(e.currentTarget).data('tcldbid')
            });
        });
    }
    
    public onDeleteBanButtonClick(callback: (id: string) => {}) {
        this.$base.find('.deleteBan').on('click', (e: any) => {
            callback($(e.currentTarget).data('id'));
        });
    }
    
    public onSaveButtonClick(callback: () => {}) {
        this.$base.find('.saveConfig').on('click', () => {
            callback();
        });
    }
    
    public onResetSettingsButtonClick(callback: () => {}) {
        this.$base.find('.resetTSPermissions').on('click', (e) => {
            e.preventDefault();
            callback();
        });
    }
    
    public onGenerateBackupButtonClick(callback: () => {}) {
        this.$base.find('.generateBackup').on('click', () => {
            callback();
        });
    }
    
    public onDeleteBackupButtonClick(callback: (id: string) => {}) {
        this.$base.find('.deleteBackup').on('click', (e: any) => {
            callback($(e.currentTarget).data('id'));
        });
    }
    
    public onApplyBackupButtonClick(callback: (id: string) => {}) {
        this.$base.find('.applyBackup').on('click', (e: any) => {
            callback($(e.currentTarget).data('id'));
        });
    }
    
    public onGenerateTokenButtonClick(callback: () => {}) {
        this.$base.find('.generateToken').on('click', () => {
            callback();
        });
    }
    
    public onDeleteTokenButtonClick(callback: (token: string) => {}) {
        this.$base.find('.deleteToken').on('click', (e: any) => {
            callback($(e.currentTarget).data('token'));
        });
    }

    public onCopyAdressButtonClick() {
        this.$base.find('.voiceserver__facts__copy').on('click', (e: any) => {
            const addressElements = this.$base.find('.voiceserver__facts__address').get();
            if (addressElements[0] != null) Utils.copyToClipboard(addressElements[0]);
        });
    }
    
    public getSelectedTokenGroup() {
        const bodyFormData = new FormData();
        bodyFormData.append('group', this.$base.find('#token_group').val() as string);
        return bodyFormData;
    }
    
    public getConfigurationValues() {
        const bodyFormData = new FormData();
        let form = document.forms['teamspeak-settings'];
        
        [].slice.call(form).forEach(function (el, i) {
            let element = $(el);
            if (element.attr('name') !== undefined) {
                if (element.is(':checkbox')) {
                    let checkboxIndex = element.data('index');
                    if (window.checkboxes[checkboxIndex].ui.active) {
                        bodyFormData.append(element.attr('name'), '1');
                    } else {
                        bodyFormData.append(element.attr('name'), '0');
                    }
                } else {
                    bodyFormData.append(element.attr('name'), element.val() as string);
                }
            }
        });
        
        return bodyFormData;
    }
}

export function createTeamspeakUI(): TeamspeakUI[] {
    const $base = $(TEAMSPEAK_SELECTOR);
    let instances: TeamspeakUI[] = [];
    
    $base.each(() => {
        instances.push(new TeamspeakUI($base))
    });
    
    return instances;
}
